<template>
  <StepTotalPrice title="Page total" :price="activeOverhead?.sum" />
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import StepTotalPrice from "@/shared/ui/StepTotalPrice.vue";
import { useSpacesStore } from "@/stores/new/spaces.store";

import { useOverheadStore } from "@/stores/new/overhead.store";
import { PricingService } from "@/app/services/pricing.service";

const spacesStore = useSpacesStore();
const overheadStore = useOverheadStore();
const activeOverhead = computed(() => overheadStore.activeOverhead);
const activeSpace = computed(() => spacesStore.activeSpace);

const pricingService = new PricingService();
const overheadItems = computed(
  () =>
    activeSpace.value
      ?.getOverheads()
      ?.components.map((item) => item.sum.serialize()) || [],
);

watch(
  () => overheadItems.value,
  () => {
    const sum = pricingService.calculateOverheadTotalPrice();

    activeOverhead.value?.update({
      sum,
    });
  },
  { immediate: true, deep: true },
);
</script>

<style lang="scss" scoped></style>
